import type { GuideTag } from '../../../shared/domain/guides/types.no-deps'
import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import type { KnownUnit } from '../unit/unit'
import type * as Guide from '../../../shared/domain/guides/types.no-deps'
import type { FileId } from '../../../shared/domain/files'
import type { AppFileGuideDetails, AppGuide } from '../guide/Model'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'

function getUnitIdFromLoopPaths(loopPathIds: LoopPathIds) {
    if (loopPathIds.length === 0) {
        return null
    }

    /* Once inside the loop, there should only be one subject inside the loopPathIds array */
    return loopPathIds[0].unitId
}

export function filterGuidesByTags(
    element: Flows.NestedGuideElement,
    elementGuideContext: {
        fileGuideDetailsMap: Map<FileId, AppFileGuideDetails>
        guidesMap: Map<Guide.Id, AppGuide>
    },
    subjectUnit: KnownUnit,
    loopPathIds: LoopPathIds
) {
    const unitIdToFilterOn =
        element.dynamicGuideSettings.source === 'reportSubject' ? subjectUnit?.id : getUnitIdFromLoopPaths(loopPathIds)

    const hasTagId = (tags: GuideTag[] | string[], tagId: number) =>
        tags
            .filter((tag: GuideTag) => tag.id)
            .map((guideTag: GuideTag) => guideTag.id)
            .includes(tagId)

    return [...elementGuideContext.guidesMap.values()].filter(
        (guide: AppGuide) =>
            guide.units.includes(unitIdToFilterOn) &&
            guide.tags &&
            hasTagId(guide.tags, element.dynamicGuideSettings.tagId)
    )
}
